import React, { useState } from 'react';

interface ProductDescriptionTooltipProps {
  description: string | null;
  productId: string;
}

const ProductDescriptionTooltip: React.FC<ProductDescriptionTooltipProps> = ({ 
  description, 
  productId
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent card selection when clicking the button
    e.preventDefault();
    setIsPopupOpen(!isPopupOpen);
  };

  const handleClosePopup = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsPopupOpen(false);
  };

  if (!description) {
    return null;
  }

  return (
    <>
      {/* Question mark button - shown on all screen sizes */}
      <button
        type="button"
        className="product-tooltip-btn"
        onClick={handleButtonClick}
        aria-label="Show product description"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.6" />
          <path
            d="M12 11.5V17"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
          <circle cx="12" cy="8" r="1.2" fill="currentColor" />
        </svg>
      </button>

      {/* Popup overlay - shown on all screen sizes */}
      {isPopupOpen && (
        <div className="product-popup-overlay" onClick={handleClosePopup}>
          <div className="product-popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="product-popup-header">
              <h3 className="product-popup-title">Description</h3>
              <button
                type="button"
                className="product-popup-close"
                onClick={handleClosePopup}
                aria-label="Close"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 6L6 18M6 6l12 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="product-popup-body">
              {description}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductDescriptionTooltip;

